var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5255_25004)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5255_25004",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3477 25.1133C26.3477 16.829 33.0634 10.1133 41.3477 10.1133C49.6319 10.1133 56.3477 16.829 56.3477 25.1133C56.3477 33.3976 49.6319 40.1133 41.3477 40.1133C33.0634 40.1133 26.3477 33.3976 26.3477 25.1133Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.3477 25.1133C26.3477 16.829 33.0634 10.1133 41.3477 10.1133C49.6319 10.1133 56.3477 16.829 56.3477 25.1133C56.3477 33.3976 49.6319 40.1133 41.3477 40.1133C33.0634 40.1133 26.3477 33.3976 26.3477 25.1133Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.092 30.7724C40.2435 30.7724 39.4878 30.6265 38.8249 30.3349C38.1658 30.0394 37.645 29.6341 37.2624 29.119C36.8836 28.6 36.6886 28.0015 36.6772 27.3235H39.1545C39.1696 27.6076 39.2624 27.8576 39.4329 28.0735C39.6071 28.2856 39.8382 28.4504 40.1261 28.5678C40.4139 28.6853 40.7378 28.744 41.0977 28.744C41.4727 28.744 41.8041 28.6777 42.092 28.5451C42.3799 28.4125 42.6052 28.2288 42.7681 27.994C42.931 27.7591 43.0124 27.4883 43.0124 27.1815C43.0124 26.8709 42.9253 26.5962 42.7511 26.3576C42.5806 26.1152 42.3344 25.9258 42.0124 25.7894C41.6942 25.6531 41.3155 25.5849 40.8761 25.5849H39.7908V23.7781H40.8761C41.2473 23.7781 41.5749 23.7137 41.859 23.5849C42.1469 23.4561 42.3704 23.2781 42.5295 23.0508C42.6886 22.8197 42.7681 22.5508 42.7681 22.244C42.7681 21.9523 42.698 21.6966 42.5579 21.4769C42.4215 21.2534 42.2283 21.0792 41.9783 20.9542C41.7321 20.8292 41.4442 20.7667 41.1147 20.7667C40.7814 20.7667 40.4764 20.8273 40.1999 20.9485C39.9234 21.0659 39.7018 21.2345 39.5352 21.4542C39.3685 21.6739 39.2795 21.9315 39.2681 22.2269H36.9102C36.9215 21.5565 37.1128 20.9656 37.484 20.4542C37.8552 19.9428 38.3552 19.5432 38.984 19.2553C39.6166 18.9637 40.3306 18.8178 41.1261 18.8178C41.9291 18.8178 42.6317 18.9637 43.234 19.2553C43.8363 19.547 44.3041 19.9409 44.6374 20.4371C44.9746 20.9296 45.1412 21.4826 45.1374 22.0962C45.1412 22.7478 44.9386 23.2913 44.5295 23.7269C44.1242 24.1625 43.5958 24.439 42.9442 24.5565V24.6474C43.8003 24.7572 44.4518 25.0546 44.8988 25.5394C45.3496 26.0205 45.573 26.6228 45.5692 27.3462C45.573 28.0091 45.3817 28.5981 44.9954 29.1133C44.6128 29.6284 44.0844 30.0337 43.4102 30.3292C42.7359 30.6246 41.9632 30.7724 41.092 30.7724Z",
    fill: "#183366"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7971 36.5772C47.4284 37.0443 47.037 37.4721 46.6255 37.8563C45.0937 39.2869 43.285 40.1133 41.3477 40.1133H46.3477C46.7497 40.1133 47.148 40.0975 47.542 40.0664C48.1913 40.0153 48.829 39.9228 49.4524 39.7916C50.3652 39.5995 51.2474 39.3244 52.0908 38.9745C52.091 38.3358 51.968 37.6865 51.7081 37.0598C51.2066 35.8504 50.2852 34.9423 49.183 34.4344C48.7694 35.2157 48.3049 35.9337 47.7971 36.5772ZM50.2999 31.8048C50.6092 33.3958 51.6849 34.8064 53.2942 35.4737C54.6138 36.021 56.0337 35.9611 57.2433 35.4227C58.0562 34.5639 58.7686 33.6091 59.3618 32.577C60.6252 30.3789 61.3477 27.8305 61.3477 25.1133C61.3477 22.3961 60.6252 19.8476 59.3618 17.6495C58.7686 16.6175 58.0562 15.6626 57.2433 14.8038C56.0337 14.2654 54.6138 14.2056 53.2942 14.7528C51.6849 15.4202 50.6092 16.8308 50.2999 18.4217C50.585 19.2782 50.8171 20.1813 50.9897 21.1213C51.223 22.3924 51.3477 23.731 51.3477 25.1133C51.3477 26.4956 51.223 27.8342 50.9897 29.1052C50.8171 30.0453 50.585 30.9484 50.2999 31.8048ZM52.0908 11.252C51.2474 10.9022 50.3652 10.6271 49.4524 10.435C48.829 10.3038 48.1913 10.2113 47.542 10.1601C47.148 10.1291 46.7497 10.1133 46.3477 10.1133H41.3477C43.285 10.1133 45.0937 10.9397 46.6255 12.3702C47.037 12.7545 47.4284 13.1823 47.7971 13.6494C48.3049 14.2928 48.7694 15.0108 49.183 15.7921C50.2852 15.2843 51.2066 14.3762 51.7081 13.1668C51.968 12.54 52.091 11.8907 52.0908 11.252Z",
    fill: "#183366",
    mask: "url(#path-1-inside-1_5255_25004)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5255_25004",
    x: 0.347656,
    y: 0.113281,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5255_25004"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5255_25004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5255_25004",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3Icon);
export default __webpack_public_path__ + "static/media/Number3Icon.00e255d4dd106b2da793b2201b3dba62.svg";
export { ForwardRef as ReactComponent };